import React from 'react';
import DirectBookings from '../../components/AdminNext/DirectBookings';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Direct bookings — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <DirectBookings />
      </HeadLessLayout>
    )
  };
}

export default action;
